import VueIcon from "./index.vue";
export default {
  install(Vue) {
    Vue.component(VueIcon.name, VueIcon);
  },
};
